export default __webpack_public_path__ + "static/media/login-hero-xs.a1d2b4dc.jpg";